"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * validates an Object is the correct format for a price dimension
 * @param {Object} priceDimension
 */
function validatePriceDimension(priceDimension) {
  if (Object.prototype.toString.call(priceDimension) !== '[object Object]' && Object.prototype.toString.call(_objectSpread({}, priceDimension)) !== '[object Object]') {
    throw new Error('priceDimension must be an object');
  }

  if (Object.keys(priceDimension).length <= 1) {
    throw new Error('priceDimension must be an object with at least 2 keys');
  }
}
/**
* calculates the slope of a line extending off the end of a price table
* @param {Object} priceDimension price table object off of whose end you wish to extrapolate
* @yields {number} the slope of the line used for extrapolation
*/


function getDelta(priceDimension) {
  validatePriceDimension(priceDimension);
  var lastKey = Object.keys(priceDimension)[Object.keys(priceDimension).length - 1];
  var secondLastKey = Object.keys(priceDimension)[Object.keys(priceDimension).length - 2];
  return priceDimension[lastKey] - priceDimension[secondLastKey];
}
/**
* finds the last KEY in a price table
* e.g. getMax({ "5": 100, "10": 200, "15": 300 }) => 15
* @param {Object} priceDimension price table object you want to find the max index of
* @yields {number} the max entry in a price table dimension
*/


function getMax(priceDimension) {
  validatePriceDimension(priceDimension);
  var lastKey = Object.keys(priceDimension)[Object.keys(priceDimension).length - 1];
  return parseInt(lastKey, 10);
}
/**
 * find the distance between the last two keys in a price table for price extrapolation
 *
 * @param {Object} priceDimension  price table object for which you want to
 * find the distance between the last two keys for price extrapolation
 */


function getDimensionDelta(priceDimension) {
  validatePriceDimension(priceDimension);
  var lastKey = Object.keys(priceDimension)[Object.keys(priceDimension).length - 1];
  var secondLastKey = Object.keys(priceDimension)[Object.keys(priceDimension).length - 2];
  return parseInt([lastKey], 10) - parseInt([secondLastKey], 10);
}
/**
 * extracts or extrapolates a price from a Shine price table
 * @param {Object} priceDimension - an list of prices
 * @param {number} quantity - an integer
 * @yields {number} price - the price at <quantity>
 */


function getPrice(priceDimension, quantity) {
  var price;
  var max = getMax(priceDimension);
  var delta = getDimensionDelta(priceDimension);

  if (quantity > max) {
    price = priceDimension[max] + (quantity - max) * getDelta(priceDimension) / delta;
  } else {
    price = priceDimension[quantity];
  }

  return price || 0;
}
/**
 * calculates the quantity that will be printed,
 * given the desired quantity and the number up
 * @param {number} quantity - the quantity needed
 * @param {number} divisor - the number printed on a sheet
 * @yields {number} the quantity that will be printed
 */


function downUpRoundQuantity(quantity, divisor) {
  if (quantity === 0) return 0;
  var y = Math.ceil(quantity / divisor);
  var x = y * Number(divisor);
  return x;
}

module.exports = {
  validatePriceDimension: validatePriceDimension,
  getDelta: getDelta,
  getMax: getMax,
  getDimensionDelta: getDimensionDelta,
  getPrice: getPrice,
  downUpRoundQuantity: downUpRoundQuantity
};